import AccountRepository from '@/shared/http/repositories/access/account'
import UserRepository from '@/shared/http/repositories/nxSenhas/usuario'
import { mutationTypes as mutation } from './mutations'

const GET_ACCOUNT_BY_ID = 'getAccountById'
const GET_ALL_ACCOUNTS = 'getAllAccounts'
const GET_LOGGED = 'getLogged'
const SET_LOGGED = 'setLogged'
const GET_LOGGED_FILA = 'getLoggedFila'
const SET_LOGGED_FILA = 'setLoggedFila'

export const actionTypes = {
  GET_ACCOUNT_BY_ID,
  GET_ALL_ACCOUNTS,
  GET_LOGGED,
  SET_LOGGED,
  GET_LOGGED_FILA,
  SET_LOGGED_FILA
}

export const actions = {
  [GET_ACCOUNT_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_ACCOUNT, payload)
  },

  async [GET_ALL_ACCOUNTS] ({ commit }, payload) {
    AccountRepository.GetAll(payload)
      .then((res) => {
        commit(mutation.SET_ACCOUNTS, res.data)
      })
  },

  [GET_LOGGED] ({ commit }, payload) {
    return AccountRepository.GetLogged()
      .then((response) => {
        commit(mutation.SET_ACCOUNT, response.data)
      })
      .catch(() => {
      })
  },

  [SET_LOGGED] ({ commit }, payload) {
    commit(mutation.SET_ACCOUNT, payload)
  },

  [GET_LOGGED_FILA] ({ commit }, payload) {
    return UserRepository.GetLoggedFila()
      .then((response) => {
        commit(mutation.SET_ACCOUNT_FILA, response.data)
      })
      .catch(() => {
      })
  },

  [SET_LOGGED_FILA] ({ commit }, payload) {
    commit(mutation.SET_ACCOUNT_FILA, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/account/actions.js